import { ReduxHelper } from 'helpers';
import { IPaymentMethod } from 'models';
import { IPaginateRequest } from 'models/RequestModels';

export const prefix = 'PAYMENT_METHODS';

export const getAllPaymentMethods = ReduxHelper.generateActions<IPaginateRequest, IPaymentMethod[]>(`${prefix}/GET_ALL_PAYMENT_METHODS`)
export const createPaymentMethod = ReduxHelper.generateActions<Partial<IPaymentMethod>, IPaymentMethod>(`${prefix}/CREATE_PAYMENT_METHOD`);
export const updatePaymentMethod = ReduxHelper.generateActions<IPaymentMethod, IPaymentMethod>(`${prefix}/UPDATE_PAYMENT_METHOD`);
export const deletePaymentMethod = ReduxHelper.generateActions<string, string>(`${prefix}/DELETE_PAYMENT_METHOD`);